export default {
  namespaced: true,
  state: {
    owner: null,
    sunflowerSeeds: false,
    rapeSeeds: false,
    soyBean: false,
    refining: false,
    esterifying: false,
    extractPress: null
  },
  mutations: {
    setOwner(state, owner) {
      state.owner = owner;
    },
    setSunflowerSeeds(state, sunflowerSeeds) {
      state.sunflowerSeeds = sunflowerSeeds;
    },
    setRapeSeeds(state, rapeSeeds) {
      state.rapeSeeds = rapeSeeds;
    },
    setSoyBean(state, soyBean) {
      state.soyBean = soyBean;
    },
    setRefining(state, refining) {
      state.refining = refining;
    },
    setEsterifying(state, esterifying) {
      state.esterifying = esterifying;
    },
    setExtractPress(state, extractPress) {
      state.extractPress = extractPress;
    }
  },
  getters: {
    owner(state) {
      return state.owner;
    },
    sunflowerSeeds(state) {
      return state.sunflowerSeeds;
    },
    rapeSeeds(state) {
      return state.rapeSeeds;
    },
    soyBean(state) {
      return state.soyBean;
    },
    refining(state) {
      return state.refining;
    },
    esterifying(state) {
      return state.esterifying;
    },
    extractPress(state) {
      return state.extractPress;
    },
    all(state) {
      return state;
    }
  }
};
